import { BdsLoadingSpinner, BdsPaper } from 'blip-ds/dist/blip-ds-react/components';
import './LoadingSpinner.scss';

export const LoadingSpinner = () => {
  return (
    <BdsPaper class="container" data-testid="loading-spinner">
      <BdsLoadingSpinner />
    </BdsPaper>
  );
};
